import { render, staticRenderFns } from "./ExpenseInfo.vue?vue&type=template&id=0ea23e32&scoped=true&"
import script from "./ExpenseInfo.vue?vue&type=script&lang=js&"
export * from "./ExpenseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea23e32",
  null
  
)

export default component.exports